import styled from "styled-components";

export const ContainerAbsolute = styled.div`
    position: ${props =>(props.$fullScreen ? 'absolute' : 'relative')};
    height: ${props =>(props.$fullScreen ? '100%' : 'auto')};
    width: ${props =>(props.$fullScreen ? '100%' : '100%')};
    background: #fff;
    z-index: 1006;
    left: 0;
    top: 0;
`;

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 9px;
    height: 250px;
    border: ${props =>('2px solid ' + props.color)};
    flex-direction: ${props =>(props.$fullScreen ? 'row-reverse' : 'column')};
`;

export const ContainerGraph = styled.div`
    display: flex;
    width: ${props =>(props.$fullScreen ? '80%' : '100%')};; 
    justify-content: center;
    align-items: center; 
    height: 240px;
    margin-top: 15px;
`;

export const LegendContainer = styled.div`
    display: flex;
    flex-direction: ${props =>(props.$fullScreen ? 'column' : 'row')};
    justify-content: flex-start;
    align-items: center;
    width: ${props =>(props.$fullScreen ? '20%' : '100%')};
    min-width: 190px;
    padding: 10px;
    gap: 10px;
`;

export const ContainerName = styled.div`
    border-radius: 5px;
    background: #FFF;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    padding: 20px;
    color: #333;
    align-self: flex-start;
    width: fit-content;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const Variablesindicator = styled.div`
    display: flex;
    flex-direction: ${props =>(props.$fullScreen ? 'column' : 'row')};
    justify-content: center;
    align-items: center;
    width: fit-content;
    gap: 10px;
`;

export const VariableLegend = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 20px;
    color: #333;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
`;

export const VariableColor = styled.div`
    display: flex;
    background: ${props=>(props.$color)};
    width: 33.555px;
    height: 33.555px;
    min-width: 33.555px;
    min-height: 33.555px;
    border-radius: 3.507px;
`;

export const ButtonTime = styled.button`
    width: 115.023px;
    height: 27.691px;
    border-radius: 4.92px;
    background: ${props =>(props.$selected ? '#006560' : '#F2F2F2')};
    box-shadow: 2.237px 2.237px 2.952px 0px rgba(43, 73, 133, 0.25);
    border: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    color: ${props =>(props.$selected ? '#F2F2F2' : '#333')};;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 116.508%; /* 18.641px */
`;

export const TimeSelector = styled.select`
    display: flex;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-align: center;
    cursor: pointer;
    outline: none;
    background: #fff;
    padding: 8px;
    border: 1px solid #333;
`;

export const StyledOption = styled.option`
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 12px;
    font-weight: 700; 
    font-style: normal;
    text-align: start;
    line-height: 0;
`;

export const Headers = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const ButtonFullScreen = styled.button`
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding: 10px;
    background: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const ScaleText = styled.h1`
    color: #333;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    text-align: left;
    max-width: 100%;
`;